import { promiseWrapper } from 'utils/promise'
import { BankInfo } from 'models/bank-info'

declare let USER_BASE_URL_IK: string

let allBanks: BankInfo[] = []

const bankInfoService = {
  all: (): BankInfo[] => allBanks,
  fetchBanks: (): Promise<BankInfo[]> => {
    return promiseWrapper<BankInfo[], never>(`${USER_BASE_URL_IK}/api/public/supportedBanks`, 'GET').then((data) => {
      allBanks = data
      return allBanks
    })
  },
  filterOthers: (): BankInfo[] => allBanks.filter((bank) => !['other', 'otherforeign'].includes(bank.bank_id)),
  oneByBankId: (bankId: string): BankInfo | undefined => bankInfoService.all().find((bank) => bank.bank_id === bankId),
}

export default bankInfoService
